(() => {
  if (!customElements.get("cart-suggestions")) {
    class CartSuggestions extends HTMLElement {
      constructor() {
        super();
        this.productContainer = null;
        this.productCount = 8;
      }

      async connectedCallback() {
        this.productContainer = document.querySelector(".js-cart-drawer__products-holder");
        if (!this.productContainer) {
          return;
        }

        this.products = [];
        this.productContainer.querySelectorAll(".js-cart-product").forEach((product) => {
          this.products.push({
            id: product.getAttribute("data-product-id"),
            price: product.getAttribute("data-product-price"),
          });
        });

        const product = this.products.reduce((acc, curr) => {
          if (acc.price > curr.price) {
            return acc;
          }
          return curr;
        });

        this.productID = product.id;

        try {
          const response = await fetch(
            `${
              window.Shopify.routes.root
            }recommendations/products?product_id=${this.productID}&limit=${this.productCount}&section_id=cart-drawer-suggestion-slide`,
          );
          const responseText = await response.text();
          if (!response.ok) {
            throw new Error("");
          }
          const html = new DOMParser().parseFromString(responseText, "text/html");

          const productSlider = html.querySelector("product-slider");
          if (productSlider) {
            this.append(productSlider);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    customElements.define("cart-suggestions", CartSuggestions);
  }
})();
